import { motion } from 'framer-motion';

export function ScoreDisclaimer() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.7 }}
      className="mt-6 p-4 bg-blue-50 border border-blue-100 rounded-lg"
    >
      <h3 className="text-sm font-semibold text-blue-800 mb-2">Score Disclaimer</h3>
      <p className="text-sm text-blue-700">
        This calculator provides an estimate based on general scoring patterns. 
        Actual scores may vary due to:
      </p>
      <ul className="mt-2 text-sm text-blue-600 list-disc list-inside">
        <li>Yearly scoring adjustments by exam boards</li>
        <li>Question difficulty variations between exam versions</li>
        <li>Score scaling and equating processes</li>
        <li>Specific grading criteria for each exam administration</li>
      </ul>

      <div className="mt-4 pt-3 border-t border-blue-200">
        <p className="text-sm text-blue-700">
          <strong>Legal Notice:</strong> This calculator is provided for educational and informational purposes only.
        </p>
        <p className="mt-1 text-xs text-blue-600">
          SAT®, ACT®, AP®, Advanced Placement®, and other test names are registered trademarks of their respective owners 
          (College Board, ACT, Inc., etc.), which are not affiliated with and do not endorse this calculator. By using this tool, 
          you acknowledge that the results are estimates only and should not be the sole basis 
          for academic or admissions decisions.
        </p>
        <p className="mt-1 text-xs text-blue-600">
          While we strive to maintain accuracy, we make no guarantees regarding the results. 
          Students should refer to official resources for definitive information about test scoring.
        </p>
      </div>
    </motion.div>
  );
}
